module.exports = {"Terms of Service":"服务条款","Privacy Notice":"隐私权声明","Frequently Asked Questions":"常见问题","Contact Us":"联络我们"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/subfolder/cn.json
// module id = 0lpy
// module chunks = 1